module.exports = __webpack_public_path__ + "assets/img/gifts-d87408e3.png";